/*
 * Copyright (c) 2018 Bruce Schubert.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 * Modifications Copyright (c) 2019 Cédric Bodet
 */
import EnhancedWmsLayer from './api/EnhancedWmsLayer'
import EnhancedAtmosphereLayer from './api/EnhancedAtmosphereLayer'
import UsgsTopoBaseMapLayer from './api/UsgsTopoBaseMapLayer'
import UsgsImageryTopoBaseMapLayer from './api/UsgsImageryTopoBaseMapLayer'

import Globe from './components/Globe';

export {
  EnhancedWmsLayer,
  EnhancedAtmosphereLayer,
  UsgsTopoBaseMapLayer,
  UsgsImageryTopoBaseMapLayer
}

export default Globe;

